module.exports = __webpack_public_path__ + "img/metrcLogo.560e3631.webp";